import React, { useState, useEffect } from 'react';
import { Layout, Menu, Button, Dropdown, theme } from 'antd';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { MenuFoldOutlined, MenuUnfoldOutlined, UserOutlined, LogoutOutlined, SettingOutlined, FundOutlined, BarChartOutlined, PieChartOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import { getMenus } from '../services/api';
import { getUser, clearAuth } from '../utils/auth';
import ChangePasswordModal from '../components/ChangePasswordModal';

const { Header, Sider, Content } = Layout;

const iconMap = {
  Setting: <SettingOutlined />, Fund: <FundOutlined />, BarChart: <BarChartOutlined />, PieChart: <PieChartOutlined />, ShoppingCart: <ShoppingCartOutlined />,
};

function buildMenuItems(pages) {
  return pages.map(p => ({
    key: p.path || p.code,
    icon: iconMap[p.icon] || null,
    label: p.name,
    children: p.children && p.children.length > 0 ? buildMenuItems(p.children) : undefined,
  }));
}

export default function BasicLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const [menuItems, setMenuItems] = useState([]);
  const [pwdModalOpen, setPwdModalOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const user = getUser();
  const { token: { colorBgContainer } } = theme.useToken();

  useEffect(() => {
    getMenus().then(res => {
      if (res.data) {
        setMenuItems(buildMenuItems(res.data));
      }
    }).catch(() => {
      // getMenus 失败时保持空菜单，不跳转登录页
    });
  }, []);

  const handleLogout = () => {
    clearAuth();
    navigate('/login');
  };

  const onMenuClick = ({ key }) => {
    navigate(key);
  };

  return (
    <Layout style={{ height: '100vh' }}>
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <div style={{ height: 64, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: collapsed ? 16 : 20, fontWeight: 'bold' }}>
          {collapsed ? 'BI' : 'Data BI'}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={onMenuClick}
        />
      </Sider>
      <Layout>
        <Header style={{ padding: '0 24px', background: colorBgContainer, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Button type="text" icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />} onClick={() => setCollapsed(!collapsed)} />
          <Dropdown menu={{ items: [
            { key: 'change-pwd', icon: <SettingOutlined />, label: '修改密码', onClick: () => setPwdModalOpen(true) },
            { type: 'divider' },
            { key: 'logout', icon: <LogoutOutlined />, label: '退出登录', onClick: handleLogout },
          ]}}>
            <Button type="text" icon={<UserOutlined />}>{user?.nickname || user?.username}</Button>
          </Dropdown>
          <ChangePasswordModal open={pwdModalOpen} onClose={() => setPwdModalOpen(false)} />
        </Header>
        <Content style={{ margin: 16, padding: 24, background: colorBgContainer, borderRadius: 8, height: 'calc(100vh - 112px)', overflowY: 'auto', overflowX: 'hidden' }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
